<template>
	<div class="s-bg">
		<div class="s-box">
			<div class="s-title">{{titleName}}</div>
			<div class="s-page-box">
				<div class="s-input-h" @click.stop="openSelect">
					<div class="s-input-lable">*选择类型</div>
					<div class="s-input-box">
						<div class="s-input-text" @click.stop="openSelect">
							<font class="grayText" v-if="applyInfo.type==0">{{typeName}}</font>
							<font v-else>{{selectName}}</font>
						</div>
						<div class="s-sel-box" v-show="selectPupopIf">
							<div class="s-sel-ul">
								<div class="s-sel-li" v-for="(item,index) in selectList" :key="index">
									<div :class="['s-sel-cell',item.isSelect]" @click.stop="selectClick(index)">
										<font>{{item.name}}</font>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="s-desc-text" v-if="ifText1">*请选择类型</div>
				<!-- ================== -->
				<div class="s-input-h">
					<div class="s-input-lable">*联系人</div>
					<div class="s-input-box">
						<input type="text" v-model="applyInfo.name" placeholder="请输入联系人姓名" />
					</div>
				</div>
				<div class="s-desc-text" v-if="ifText2">*请输入联系人</div>
				<!-- ================== -->
				<div class="s-input-h">
					<div class="s-input-lable">*联系方式</div>
					<div class="s-input-box">
						<input type="text" v-model="applyInfo.tel" placeholder="请输入联系人方式" />
					</div>
				</div>
				<div class="s-desc-text" v-if="ifText3">*请输入联系方式</div>
				<!-- ================== -->
				<div class="s-input-h">
					<div class="s-input-lable">*地区</div>
					<div class="s-input-box">
						<input type="text" v-model="applyInfo.address" placeholder="请输入地区" />
					</div>
				</div>
				<div class="s-desc-text" v-if="ifText4">*请输入地区</div>
				<!-- ================= -->
				<div class="i-btn-box">
					<div class="s-input-btn" @click="goSumbit">提交</div>
					<div class="s-input-clear" @click="goClear">重置</div>
				</div>
			</div>
		</div>
		<div class="disappearText">{{typeInt}}</div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		props: { 
			titleName: { type: String},
			typeInt:{type:Number}
		},
		data() {
			return {
				selectName:'',
				typeName:'',
				selectList:[],
				selectPupopIf:false,
				applyInfo: {
					type: 0,
					name: '',
					tel: '',
					address: ''
				},
				ifText1:false,
				ifText2:false,
				ifText3:false,
				ifText4:false,
			}
		},
		mounted() {
			var self = this
			self.pageLoad()
		},
		methods: {
			//===初始化====
			pageLoad(){
				var self = this
				console.log('==typeInt=',self.typeInt)
				if(self.typeInt==2){
					self.typeName = '代理商/合伙人'
					self.selectList = [
						{
							type:1,
							isSelect:'select',
							name:'充电桩代理商'
						},
						{
							type:2,
							isSelect:'',
							name:'闪开合伙人'
						},
					]
				}else{
					self.typeName = '个人/公司'
					self.selectList = [
						{
							type:1,
							isSelect:'select',
							name:'个人'
						},
						{
							type:2,
							isSelect:'',
							name:'公司'
						},
					]
				}
			},
			//选择类型
			selectClick(index){
				var self = this
				for(var i in self.selectList){
					var dataInfo = self.selectList[i]
					if(dataInfo.isSelect){
						dataInfo.isSelect = ''
					}
				}
				self.selectPupopIf = false
				var obj = self.selectList[index]
				obj.isSelect = 'select'
				self.applyInfo.type = obj.type
				self.selectName = obj.name
				console.log('type=>',self.applyInfo.type)
			},
			openSelect(){
				var self = this
				console.log('=============')
				if(self.selectPupopIf){
					self.selectPupopIf = false
				}else{
					self.selectPupopIf = true
				}
			},
			closeClick(){
				var self = this
				self.selectPupopIf = false
			},
			goClear(){
				var self = this
				self.applyInfo = {
					type: 0,
					name: '',
					tel: '',
					address: ''
				}
				self.selectName = ''
			},
			goSumbit(){
				var self = this
				self.ifText1 = false
				self.ifText2 = false
				self.ifText3 = false
				self.ifText4 = false
				if(self.applyInfo.type==0){
					self.ifText1 = true
					return
				}
				if(!self.applyInfo.name){
					self.ifText2 = true
					return
				}
				if(!self.applyInfo.tel){
					self.ifText3 = true
					return
				}
				if(!self.applyInfo.address){
					self.ifText4 = true
					return
				}
				console.log('=========>')
				self.netFormSumbit()
			},
			netFormSumbit(){
				var self = this
				let param = {
					type:self.applyInfo.type,
					name:self.applyInfo.name,
					phone:self.applyInfo.tel,
					region:self.applyInfo.address
				}
				var url = "https://issks.com/api/partner_consult/toconsult"
				if(self.typeInt == 1){
					url = "https://issks.com/api/install_apply/apply"
				}
				
				axios.post(url, param).then(res => {
					self.goClear()
					self.$message({
						message: "提交成功！",
						//type 取值 success(成功) /warning(警告)/info(消息)/error(错误)/;
						type: "success",
					});
				}).catch(err => {
				  
				})
			}
		}
	}
</script>

<style>
	.s-bg{
		background-color: #fff;
	}
	@media screen and (max-width:750px) {
		.s-box{
			width: 95%;
			margin: 1rem auto;
		}
		.s-title{
			font-size: 1.5rem;
			font-weight: bold;
			color: #8CBC4A;
		}
		/* =================== */
		.s-page-box{
			width: 90%;
			margin: .5rem auto 0;
		}
		/* ================================= */
		.s-input-h {
			padding: .8rem;
			border: .1rem solid #EEEEEE;
			margin-top: .8rem;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 1rem;
		}
		
		.s-input-lable {
			width: 20%;
			margin-right: 1rem;
			text-align: right;
			font-size: .8rem;
			font-weight: 600;
			color: #636363;
		}
		.s-input-box{
			text-align: left;
			position: relative;
		}
		.s-input-box input {
			width: 100%;
			font-size: .8rem;
		}
		.s-input-text{
			font-size: .8rem;
		}
		.s-input-text .grayText{
			color: #868686;
		}
		.i-btn-box{
			width: 80%;
			margin: 1rem auto 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
			font-size: 1rem;
			font-weight: bold;
		}
		.s-input-btn {
			width: 45%;
			padding: .5rem 0;
			background-color: #8DBB49;
			border: .1rem solid #8DBB49;
			border-radius: .8rem;
			color: #fff;
			cursor: pointer;
		}
		.s-input-clear{
			width: 45%;
			padding: .5rem 0;
			border: .1rem solid #b1b1b1;
			border-radius: .8rem;
			color: #b1b1b1;
			cursor: pointer;
		}
		/* ========================= */
		.s-sel-box{
			background-color: #fff;
			position: absolute;
			top: 140%;
			left: 0;
			z-index: 9;
		}
		.s-sel-ul{
			min-width: 10rem;
			border: .1rem solid #F1F1F1;
		}
		.s-sel-li{
			border-bottom: .1rem solid #F1F1F1;
		}
		.s-sel-li .select{
			background-color: #2ccdf1;
			color: #fff;
		}
		.s-sel-cell{
			padding: 1rem 2rem;
		}
	}
	@media screen and (min-width:755px) {
		.s-box{
			width: 70%;
			margin: 2rem auto;
		}
		.s-title{
			font-size: 2.5vw;
			font-weight: bold;
			color: #8CBC4A;
		}
		/* =================== */
		.s-page-box{
			width: 80%;
			margin: 3vw auto 0;
		}
		/* ================================= */
		.s-input-h {
			width: 100%;
			padding: 1.5vw;
			border: .1vw solid #EEEEEE;
			margin-top: 1.5vw;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-size: 1vw;
		}
		
		.s-input-lable {
			flex: 1.5;
			margin-right: 2vw;
			text-align: right;
			font-weight: 600;
			color: #636363;
		}
		.s-input-box{
			flex: 11;
			text-align: left;
			position: relative;
		}
		.s-input-box input {
			width: 100%;
			font-size: .8vw;
		}
		.s-input-text{
			font-size: .8vw;
		}
		.s-input-text .grayText{
			color: #868686;
		}
		.i-btn-box{
			width: 80%;
			margin: 4vw auto 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			text-align: center;
			font-size: 1.5vw;
			font-weight: bold;
		}
		.s-input-btn {
			width: 45%;
			padding: 1vw 0;
			background-color: #8DBB49;
			border: .1vw solid #8DBB49;
			border-radius: .8vw;
			color: #fff;
			cursor: pointer;
		}
		.s-input-clear{
			width: 45%;
			padding: 1vw 0;
			border: .1vw solid #b1b1b1;
			border-radius: .8vw;
			color: #b1b1b1;
			cursor: pointer;
		}
		/* ========================= */
		.s-sel-box{
			background-color: #fff;
			position: absolute;
			top: 140%;
			left: 0;
			z-index: 9;
		}
		.s-sel-ul{
			min-width: 10vw;
			border: .1vw solid #F1F1F1;
		}
		.s-sel-li{
			border-bottom: .1vw solid #F1F1F1;
		}
		.s-sel-li .select{
			background-color: #2ccdf1;
			color: #fff;
		}
		.s-sel-cell{
			padding: 1vw 2vw;
		}
	}
	
</style>